export const restHost = "/api/admin"

export const vendors = [
    {
    label: 'Internal',
    value: 0
  },
  {
    label: 'spruebrothers.com',
    value: 1
  },
  {
    label: 'hannants.co.uk',
    value: 6
  },
  {
    label: 'stevenshobby.com',
    value: 10
  },
  {
    label: 'kitlinx.com',
    value: 2
  },
  {
    label: 'hobbytyme.com',
    value: 7
  },
  {
    label: 'lsghobby.com',
    value: 12
  },
  {
    label: 'hhw',
    value: 13
  },
  {
    label: 'hlj.com',
    value: 14
  }
]

export function getVendorLogo(vendor)
{
    switch (vendor)
    {
        case "spruebrothers.com":
            return "https://cdn11.bigcommerce.com/s-hmlqrqdpah/images/stencil/original/carousel/16/CartslideV2_102621.jpg";
        case "hannants.co.uk":
            return "https://www.hannants.co.uk/images/old_logo.gif";
        case "stevenshobby.com":
            return "https://stevenshobby.com/images/logo.jpg";
        case "kitlinx.com":
            return "https://www.kitlinx.com/images/kitlinx-top-logo.png";
        case "hobbytyme.com":
            return "https://www.hobbytyme.com/images/hobbytyme.png";
        case "lsghobby.com":
            return "https://www.lsghobby.com/css/Content/img/header.lsg.png";
        case "HHW":
            return "https://400.vsa1.com:8088/hhw/images/heartland.gif";
        case "hlj.com":
            return "https://d1gt5dppxgb6oq.cloudfront.net/topimg/New_Toppage_Com/hlj-logo.jpg";
        default:
        return "https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse4.mm.bing.net%2Fth%3Fid%3DOIP.Y_epYDyL6zfaAqkDZs4nhAHaHa%26pid%3DApi&f=1";
    }
}


export function getVendorId(vendor)
{
    for(var i=0; i < vendors.length; i++)
    {
        if(vendors[i].label === vendor){
            return vendors[i].value;
        }
    }

    return -1;
}

export function getVendorName(id)
{
    switch (id)
    {
        case 0:
            return "Internal";
        case 1:
            return "spruebrothers.com";
        case 6:
            return "hannants.co.uk";
        case 10:
            return "stevenshobby.com";
        case 2:
            return "kitlinx.com";
        case 7:
            return "hobbytyme.com";
        case 12:
            return "lsghobby.com";
        case 13:
            return "hhw";
        case 14:
            return "hlj.com";
        default:
        return "Unkown";
    }
}
